import dayjs from 'dayjs';
import _ from 'lodash';
import React, { useContext, useMemo } from 'react';
import { CalendarContext } from '@modules/planner/calendar/calendar-context';
import { CalendarDataType } from '@modules/planner/calendar/calendar-types';
import { getTaskBoundaries } from '@modules/planner/calendar/utils';
import { getTaskStart } from '@modules/planner/calendar/utils/get-task-start';
import { getTaskWidth } from '@modules/planner/calendar/utils/get-task-width';
import { AbsenceElement } from '@composite/absence-bar/absence-element';
import { getAbsences } from '@composite/calendar/utils';
import { Absence } from '@models';

export function AbsenceBar({ barData }: { barData: CalendarDataType }) {
  const { settings, currentDate, dataSource } = useContext(CalendarContext);

  const absences = useMemo(() => {
    return _.uniqBy(
      barData.shifts
        ?.map((shift, index) => {
          return shift?.isBlockingException
            ? undefined
            : getAbsences(
                barData.absences,
                dayjs.unix(currentDate).add(index, 'day').format('YYYY-MM-DD')
              );
        })
        .flat(),
      'id'
    );
  }, [barData.absences, barData.shifts, currentDate]);

  if (!absences || absences.length === 0) {
    return <></>;
  }
  const formattedAbsences = absences
    .map((absence) => {
      if (!absence) return null;
      const { workOrderStart, workOrderEnd } = getTaskBoundaries(
        currentDate,
        settings,
        absence,
        true
      );
      const start = getTaskStart(
        currentDate,
        workOrderStart,
        workOrderEnd,
        settings
      );
      const width = getTaskWidth(
        currentDate,
        workOrderStart,
        workOrderEnd,
        settings
      );
      return { start, width, absence };
    })
    .filter((a) => !!a) as {
    start: number;
    width: number;
    absence?: Absence;
  }[];

  return (
    <>
      {formattedAbsences.map(({ start, width, absence }, index) => {
        if (!absence) return null;
        return (
          <AbsenceElement
            key={index}
            absence={absence}
            left={start}
            width={width}
            refreshData={() => {
              dataSource.yAxis.refreshData?.();
            }}
          />
        );
      })}
    </>
  );
}
